import * as Sentry from '@sentry/react';
import { ledgerIconToIcon } from 'bank-common';
import * as React from 'react';
import type { LedgerCategoryIcon } from '../gqltypes';
import * as icons from '../icons';

type IconProps = React.SVGProps<SVGSVGElement>;

const iconsById: Record<string, React.ReactElement<IconProps>> = {
  AirplaneUpIcon: <icons.AirplaneUpIcon />,
  Airplane2Icon: <icons.Airplane2Icon />,
  ArrowDownIcon: <icons.ArrowDownIcon />,
  ArrowLeftIcon: <icons.ArrowLeftIcon />,
  ArrowRightIcon: <icons.ArrowRightIcon />,
  ArrowUpIcon: <icons.ArrowUpIcon />,
  ArrowsAroundIcon: <icons.ArrowsAroundIcon />,
  ArrowsBothWaysInOneIcon: <icons.ArrowsBothWaysInOneIcon />,
  ArrowsRightLeftIcon: <icons.ArrowsRightLeftIcon />,
  ArrowsWithCircleIcon: <icons.ArrowsWithCircleIcon />,
  BananastandIcon: <icons.BananastandIcon />,
  BanknoteAltIcon: <icons.BanknoteAltIcon />,
  BanknoteIcon: <icons.BanknoteIcon />,
  BellAlertsNotificationIcon: <icons.BellAlertsNotificationIcon />,
  BookIcon: <icons.BookIcon />,
  BreadIcon: <icons.BreadIcon />,
  BriefcaseIcon: <icons.BriefcaseIcon />,
  BuildingIcon: <icons.BuildingIcon />,
  BuildingLocationIcon: <icons.BuildingLocationIcon />,
  BusIcon: <icons.BusIcon />,
  CalculatorIcon: <icons.CalculatorIcon />,
  CalendarEmptyIcon: <icons.CalendarEmptyIcon />,
  CalendarFoodIcon: <icons.CalendarFoodIcon />,
  CalendarGraphIcon: <icons.CalendarGraphIcon />,
  CameraIcon: <icons.CameraIcon />,
  CarIcon: <icons.CarIcon />,
  CardIcon: <icons.CardIcon />,
  CartIcon: <icons.CartIcon />,
  ChampagneIcon: <icons.ChampagneIcon />,
  ChatIcon: <icons.ChatIcon />,
  CheckForYesIcon: <icons.CheckForYesIcon />,
  CheckmarkDashedIcon: <icons.CheckmarkDashedIcon />,
  CheckmarkFilledIcon: <icons.CheckmarkFilledIcon />,
  CheckmarkRoundIcon: <icons.CheckmarkRoundIcon />,
  ClipboardTagIcon: <icons.ClipboardTagIcon />,
  ClippyIcon: <icons.ClippyIcon />,
  ClockIcon: <icons.ClockIcon />,
  CloudDownIcon: <icons.CloudDownIcon />,
  CloudIcon: <icons.CloudIcon />,
  CloudStrikethroughOfflineIcon: <icons.CloudStrikethroughOfflineIcon />,
  CoffeeIcon: <icons.CoffeeIcon />,
  CogwheelGearIcon: <icons.CogwheelGearIcon />,
  CoinsIcon: <icons.CoinsIcon />,
  CompassIcon: <icons.CompassIcon />,
  CompleteIcon: <icons.CompleteIcon />,
  CompletePurpleIcon: <icons.CompletePurpleIcon />,
  ComputerIcon: <icons.ComputerIcon />,
  CopyIcon: <icons.CopyIcon />,
  DialpadIcon: <icons.DialpadIcon />,
  DiamondIcon: <icons.DiamondIcon />,
  DocumentArrowDownIcon: <icons.DocumentArrowDownIcon />,
  DotsMiscIcon: <icons.DotsMiscIcon />,
  DotsMoreIcon: <icons.DotsMoreIcon />,
  Download2Icon: <icons.Download2Icon />,
  DropIcon: <icons.DropIcon />,
  EnvelopeLetterMailIcon: <icons.EnvelopeLetterMailIcon />,
  EuroIcon: <icons.EuroIcon />,
  ExpandIcon: <icons.ExpandIcon />,
  FastFoodIcon: <icons.FastFoodIcon />,
  FilterIcon: <icons.FilterIcon />,
  FilterLinesIcon: <icons.FilterLinesIcon />,
  FingerprintIcon: <icons.FingerprintIcon />,
  FolderIcon: <icons.FolderIcon />,
  FoldingPaperIcon: <icons.FoldingPaperIcon />,
  FoodCutleryIcon: <icons.FoodCutleryIcon />,
  ForkArrowIcon: <icons.ForkArrowIcon />,
  FrownCryfaceRejectedIcon: <icons.FrownCryfaceRejectedIcon />,
  FurnitureIcon: <icons.FurnitureIcon />,
  GiftBoxIcon: <icons.GiftBoxIcon />,
  GlassesIcon: <icons.GlassesIcon />,
  GlobeIcon: <icons.GlobeIcon />,
  GlowIcon: <icons.GlowIcon />,
  GovernmentIcon: <icons.GovernmentIcon />,
  GraphUpIcon: <icons.GraphUpIcon />,
  GraphUp2Icon: <icons.GraphUp2Icon />,
  GreenCompleteCheckIcon: <icons.GreenCompleteCheckIcon />,
  GroupAddIcon: <icons.GroupAddIcon />,
  HeartIcon: <icons.HeartIcon />,
  HomeIcon: <icons.HomeIcon />,
  HourGlassIcon: <icons.HourGlassIcon />,
  ImageIcon: <icons.ImageIcon />,
  InfoIcon: <icons.InfoIcon />,
  KeyIcon: <icons.KeyIcon />,
  LegalParagraphIcon: <icons.LegalParagraphIcon />,
  LeversAltIcon: <icons.LeversAltIcon />,
  LeversIcon: <icons.LeversIcon />,
  LeversVerticalIcon: <icons.LeversVerticalIcon />,
  LinkIcon: <icons.LinkIcon />,
  LocationPinIcon: <icons.LocationPinIcon />,
  LockIcon: <icons.LockIcon />,
  LockOpenIcon: <icons.LockOpenIcon />,
  LoopLeftIcon: <icons.LoopLeftIcon />,
  LoopRightIcon: <icons.LoopRightIcon />,
  LoopRight2Icon: <icons.LoopRight2Icon />,
  MagnifyingGlassIcon: <icons.MagnifyingGlassIcon />,
  MaskIcon: <icons.MaskIcon />,
  MegaphoneIcon: <icons.MegaphoneIcon />,
  MenuLinesIcon: <icons.MenuLinesIcon />,
  MetalNutIcon: <icons.MetalNutIcon />,
  MicroCheckMiniForLabelIcon: <icons.MicroCheckMiniForLabelIcon />,
  MicroClockMiniForLabelIcon: <icons.MicroClockMiniForLabelIcon />,
  MicroCrownForBoIcon: <icons.MicroCrownForBoIcon />,
  MicroHourglassMiniForLabelsIcon: <icons.MicroHourglassMiniForLabelsIcon />,
  MicroXMiniForInvoiceIcon: <icons.MicroXMiniForInvoiceIcon />,
  MoneyBagCheckIcon: <icons.MoneyBagCheckIcon />,
  MoneyBagCleanIcon: <icons.MoneyBagCleanIcon />,
  MoneyBagDollarIcon: <icons.MoneyBagDollarIcon />,
  MoneyBagXIcon: <icons.MoneyBagXIcon />,
  MultipleCardsIcon: <icons.MultipleCardsIcon />,
  NewViewArrowDiagonalIcon: <icons.NewViewArrowDiagonalIcon />,
  NewViewIcon: <icons.NewViewIcon />,
  NightIcon: <icons.NightIcon />,
  PalmTreeHolidayIslandIcon: <icons.PalmTreeHolidayIslandIcon />,
  PaperFoldedIcon: <icons.PaperFoldedIcon />,
  PaperIcon: <icons.PaperIcon />,
  PaperPlaneIcon: <icons.PaperPlaneIcon />,
  PaperPrintTearIcon: <icons.PaperPrintTearIcon />,
  PaperScrollIcon: <icons.PaperScrollIcon />,
  PaperScrollPercentIcon: <icons.PaperScrollPercentIcon />,
  PaperScrollTextIcon: <icons.PaperScrollTextIcon />,
  PaperTearAddIcon: <icons.PaperTearAddIcon />,
  PaperTearCheckIcon: <icons.PaperTearCheckIcon />,
  PaperTearPercentIcon: <icons.PaperTearPercentIcon />,
  PaperTearTextIcon: <icons.PaperTearTextIcon />,
  ParasolHolidayIcon: <icons.ParasolHolidayIcon />,
  ParkingIcon: <icons.ParkingIcon />,
  PencilIcon: <icons.PencilIcon />,
  PencilLinesIcon: <icons.PencilLinesIcon />,
  PercentIcon: <icons.PercentIcon />,
  PersonDollarIcon: <icons.PersonDollarIcon />,
  PersonIcon: <icons.PersonIcon />,
  PersonPercentIcon: <icons.PersonPercentIcon />,
  PhoneIcon: <icons.PhoneIcon />,
  PiggybankIcon: <icons.PiggybankIcon />,
  PirateIcon: <icons.PirateIcon />,
  PizzaIcon: <icons.PizzaIcon />,
  PlusIcon: <icons.PlusIcon />,
  PlusRoundIcon: <icons.PlusRoundIcon />,
  PowerOffIcon: <icons.PowerOffIcon />,
  QuestionIcon: <icons.QuestionIcon />,
  RobotIcon: <icons.RobotIcon />,
  RocketFoundingIcon: <icons.RocketFoundingIcon />,
  SafeIcon: <icons.SafeIcon />,
  ScalesIcon: <icons.ScalesIcon />,
  ScissorsIcon: <icons.ScissorsIcon />,
  ScreamIcon: <icons.ScreamIcon />,
  ScreenIcon: <icons.ScreenIcon />,
  SelectedMenuCheckIcon: <icons.SelectedMenuCheckIcon />,
  ShareIcon: <icons.ShareIcon />,
  SmallArrowDownIcon: <icons.SmallArrowDownIcon />,
  SmallArrowLeftIcon: <icons.SmallArrowLeftIcon />,
  SmallArrowRightIcon: <icons.SmallArrowRightIcon />,
  SmallArrowUpIcon: <icons.SmallArrowUpIcon />,
  SmallGreenCompleteCheckIcon: <icons.SmallGreenCompleteCheckIcon />,
  SmallNewViewFor200Icon: <icons.SmallNewViewFor200Icon />,
  SmileyIcon: <icons.SmileyIcon />,
  SnowflakeIcon: <icons.SnowflakeIcon />,
  SoftwareCheckIcon: <icons.SoftwareCheckIcon />,
  SoftwareIcon: <icons.SoftwareIcon />,
  SpeedometerIcon: <icons.SpeedometerIcon />,
  StackSquaresAccountIcon: <icons.StackSquaresAccountIcon />,
  StationaryIcon: <icons.StationaryIcon />,
  SuitcaseIcon: <icons.SuitcaseIcon />,
  TaxiIcon: <icons.TaxiIcon />,
  TextBullet300Icon: <icons.TextBullet300Icon />,
  TombstoneIcon: <icons.TombstoneIcon />,
  TrainIcon: <icons.TrainIcon />,
  TrashcanIcon: <icons.TrashcanIcon />,
  TruckIcon: <icons.TruckIcon />,
  UmbrellaIcon: <icons.UmbrellaIcon />,
  UnknownCleanIcon: <icons.UnknownCleanIcon />,
  UploadIcon: <icons.UploadIcon />,
  WalletCoinsIcon: <icons.WalletCoinsIcon />,
  WarningIcon: <icons.WarningIcon />,
  XForCloseIcon: <icons.XForCloseIcon />,
  XForNoIcon: <icons.XForNoIcon />,
  XRoundIcon: <icons.XRoundIcon />,
};

export function getLedgerIcon(ledgerIconId: LedgerCategoryIcon) {
  const iconId = ledgerIconToIcon[ledgerIconId];
  if (!iconId) {
    Sentry.captureMessage(`Tried getting unknown ledger icon: ${ledgerIconId}`);
  }

  const icon = iconsById[iconId];
  if (!icon) {
    Sentry.captureMessage(`Tried getting unknown icon: ${iconId}`);
  }

  return icon || iconsById.UnknownCleanIcon;
}
